// extracted by mini-css-extract-plugin
export var border = "_o-8";
export var brand = "_o-t";
export var button = "_o-l";
export var center = "_o-a";
export var centered = "_o-6";
export var closeButton = "_o-c";
export var disabledWrapper = "_o-m";
export var error = "_o-p";
export var extraLarge = "_o-4";
export var extraSmall = "_o-1";
export var fill = "_o-i";
export var footer = "_o-h";
export var footerAction = "_o-j";
export var footerButtons = "_o-k";
export var header = "_o-7";
export var headerWithClose = "_o-d";
export var icon = "_o-o";
export var info = "_o-s";
export var inline = "_o-9";
export var large = "_o-3";
export var main = "_o-e";
export var modal = "_o-0";
export var nearFull = "_o-5";
export var neutral = "_o-u";
export var noPadding = "_o-g";
export var none = "_o-v";
export var scrollable = "_o-f";
export var small = "_o-2";
export var success = "_o-r";
export var tight = "_o-n";
export var titleIcon = "_o-b";
export var warn = "_o-q";